import React from 'react';

function NotyWarningIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="45"
      fill="none"
      viewBox="0 0 44 45"
    >
      <g>
        <path
          fill="#FF8A00"
          d="M22 33.873c-1.114 0-1.857-.741-1.857-1.854v-8.528c0-1.112.743-1.854 1.857-1.854 1.114 0 1.857.742 1.857 1.854v8.528c0 1.113-.743 1.854-1.857 1.854zm1.857-16.87v-.557c0-1.112-.743-1.854-1.857-1.854-1.114 0-1.857.742-1.857 1.854v.556c0 1.113.743 1.854 1.857 1.854 1.114 0 1.857-.741 1.857-1.854zm15.78 19.466a4.52 4.52 0 000-4.82L26.27 8.289c-.928-1.483-2.6-2.41-4.27-2.41-1.67 0-3.342.927-4.27 2.41L4.363 31.649a4.52 4.52 0 000 4.82c.928 1.483 2.413 2.41 4.27 2.41h26.92c1.67 0 3.342-.742 4.084-2.41zM21.072 10.143c.185-.556.742-.556.928-.556.186 0 .743 0 .928.556l13.553 23.36c.371.556.186.926 0 1.112-.186.185-.371.556-.928.556H8.447c-.557 0-.928-.37-.928-.556-.186-.186-.371-.556 0-1.113l13.553-23.359z"
        ></path>
      </g>
    </svg>
  );
}

export default NotyWarningIcon;
